<template>
  <v-container class="py-0">
    <v-row>
      <v-col>
        <div class="display-1 font-weight-normal mb-6 text-center">
          Vamos começar preenchendo as informações gerais do cálculo
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <validation-provider v-slot="{ errors, valid }" rules="required">
          <validation-helper :interceptor="valid" @isValid="$emit('step-observer-nome', { step: 'nome', complete: $event })" />
          <v-text-field v-model="nome" :error-messages="errors" label="Nome do Cálculo"></v-text-field>
        </validation-provider>
      </v-col>
      <v-col>
        <validation-provider v-slot="{ errors, valid }" rules="required">
          <validation-helper
            :interceptor="valid"
            @isValid="
              $emit('step-observer-empresa', {
                step: 'empresa',
                complete: $event
              })
            "
          />
          <v-autocomplete
            v-model="empresaSelecionada"
            :error-messages="errors"
            :items="itemsEmpresa"
            item-value="execucao_id"
            item-text="abreviacao"
            label="Empresa"
            placeholder="Selecione a Empresa"
          />
        </validation-provider>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <validation-provider v-slot="{ valid }" rules="required">
          <validation-helper
            :interceptor="valid"
            @isValid="
              $emit('step-observer-data-inicio', {
                step: 'data-inicio',
                complete: $event
              })
            "
          />
          <date-picker
            v-model="dataInicialAnalise"
            :showIcon="false"
            label="Início Incremental"
            type="date"
            :outlined="true"
            rules="required|min:7"
          />
        </validation-provider>
      </v-col>
      <v-col>
        <validation-provider v-slot="{ valid }" rules="required">
          <validation-helper
            :interceptor="valid"
            @isValid="
              $emit('step-observer-data-final', {
                step: 'data-final',
                complete: $event
              })
            "
          />
          <date-picker
            v-model="dataFinalAnalise"
            :showIcon="false"
            label="Fim Incremental"
            type="date"
            :outlined="true"
            rules="required|min:7"
          />
        </validation-provider>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import BulldozerrService from '@/services/BulldozerrService.js';
  import dayjs from 'dayjs';

  export default {
    components: {
      DatePicker: () => import('@/components/general/DatePicker.vue'),
      ValidationHelper: () => import('@/components/general/ValidationHelper.vue')
    },

    emits: ['step-observer-nome', 'step-observer-empresa', 'step-observer-data-inicio', 'step-observer-data-final'],

    data: () => ({
      nome: '',
      itemsEmpresa: [],
      empresaSelecionada: null,
      dataInicialAnalise: null,
      dataFinalAnalise: null
    }),

    mounted() {
      this.getEmpresas();
    },

    methods: {
      getEmpresas() {
        BulldozerrService.getEmpresas()
          .then((response) => {
            this.itemsEmpresa = response.data.empresas;
            const empresaAtual = this.$store.getters.getEmpresa;
            this.empresaSelecionada = this.itemsEmpresa.filter(
              (empresa) => empresa.sigla_hexa?.toLowerCase() === empresaAtual.toLowerCase()
            )[0]?.execucao_id;
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error('Ocorreu um erro ao recuperar os dados das empresas.');
          });
      },

      exportData() {
        return {
          nome: this.nome,
          dataInicialAnalise: this.dataInicialAnalise,
          dataFinalAnalise: this.dataFinalAnalise,
          empresaSelecionada: this.empresaSelecionada,
          periodoRecuperacao: this.calculatePeriodoRecuperacao(this.dataInicialAnalise, this.dataFinalAnalise)
        };
      },

      calculatePeriodoRecuperacao(dataInicial, dataFinal) {
        if (!dataInicial || !dataFinal) return null;

        const startDate = dayjs(dataInicial);
        const endDate = dayjs(dataFinal);

        const diffMonths = endDate.diff(startDate, 'month');

        return diffMonths;
      }
    }
  };
</script>
